import cleanedFilename from '~/util/cleanedFilename';

export default {
  TAG_INPUT_GROUP: `${cleanedFilename(__filename)}-tag-input-group`,
};
